import {
  ActionIcon as MantineActionIcon,
  type ActionIconProps as MantineActionIconProps,
  Tooltip,
} from "@mantine/core"
import { theme } from "@tfg/themes"
import { cloneElement, type ReactElement } from "react"

import { ButtonVariants } from "../../atoms/Button/Button"

type ActionIconProps = {
  icon: ReactElement<{ size?: number; strokeWidth?: number }>
  variant?: ButtonVariants
  toolTip?: string
  size?: number
  stroke?: number
  loading?: boolean
} & React.DOMAttributes<HTMLButtonElement> &
  MantineActionIconProps

export const ActionIcon = ({
  icon,
  variant = "secondary",
  toolTip,
  size,
  stroke,
  ...props
}: ActionIconProps) => {
  if (!icon) return null
  const finalSize = size || theme.other.icon.size
  const finalStroke = stroke || theme.other.icon.stroke
  const iconSized = cloneElement<{ size?: number; strokeWidth?: number }>(
    icon,
    {
    size: finalSize,
    strokeWidth: finalStroke,
    }
  )

  const iconElement = (
    <MantineActionIcon
      h={finalSize * 1.5}
      w={finalSize * 1.5}
      loaderProps={{
        size: finalSize * 1.5,
        type: "oval",
      }}
      variant={variant}
      title={toolTip}
      {...props}
    >
      {iconSized}
    </MantineActionIcon>
  )
  return toolTip ? (
    <Tooltip label={toolTip}>{iconElement}</Tooltip>
  ) : (
    iconElement
  )
}
